import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { CampaignRequestModel } from '../business-entities/campaign-modal';

@Injectable({
  providedIn: 'root'
})
export class CampaignDataServiceService {

  constructor(private dataService: DataService) { }

  getCampaigns(campaignRequestModel: CampaignRequestModel): Promise<any> {
    return this.dataService.GetForCampaignServicePayload(Urls.Campaign,campaignRequestModel).toPromise();
  }

  getCampaignById(id): Promise<any>{
    return this.dataService.GetForCampaignServiceWithParam(Urls.Campaign,id).toPromise();
  }

  addUpdateCampaigns(param: any): Promise<any>{
    return this.dataService.PostForCampaignService(Urls.Campaign, param).toPromise();
  }

  deleteCampaign(id): Promise<any>{
    return this.dataService.DeleteForCampaignService(Urls.Campaign,id).toPromise();
  }
}
